export enum JourneyStopType {
  Donation = 'Donation',
  Store = 'Store',
  Partner = 'Partner',
  Truck = 'Truck',
  Custom = 'Embedded::JourneyJob',
}
